import axios from '../common/axios';

// 搜索学校
export const searchSchools = (value, count = 5) =>
  axios.get('/search/schools', {
    keyword: value,
    pageSize: count,
    silent: true,
  });
